<template>
  <div class="rounded-circle bg-white avatar-wrapper ml-auto mr-auto p-4">
    <font-awesome-icon icon="user" class="fs-47"/>
  </div>
</template>

<script>
export default {
  name: 'AvatarDummy'
}
</script>

<style>

</style>
